export enum OrderAssetAvailability {
    FullMatch = 1,
    PartialMatch = 2,
    NoMatch = 3
}
